var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContactManagementConfigContext } from '../../../ui/providers';
import { usePlatformLoader } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
/**
 * @deprecated
 * will be removed, DO NOT USE in new code!
 * Use onStatelessReload or onReload from usePlatformLoader
 */
export const useInvalidateState = () => {
    const { appContext } = React.useContext(ContactManagementConfigContext);
    const appContextValue = React.useContext(appContext);
    const { onStatelessReload } = usePlatformLoader({ appContext });
    const { invalidateState: appContextInvalidateState } = appContextValue;
    const invalidateState = () => __awaiter(void 0, void 0, void 0, function* () {
        return appContextInvalidateState().then((userState) => {
            onStatelessReload();
            return userState;
        });
    });
    return {
        invalidateState,
    };
};
